<template>
  <div class="parent">
    <ul class="ul-init">
      <li
        :key="item.index"
        v-for="item in flowData"
        :class="{ active: item.index === checkedIndex }"
        @click="itemClick(item.index, item)"
      >
        <span>{{ item.desc }}</span>
        <div></div>
      </li>
      <li class="studyLi">
        <div class="divStudy" @click="qimoChatClick">马上学习</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      localHeight: 0,
      speed: 100,
      nextHeight: 0,
      checkedIndex: 0,
    };
  },
  props: {
    flowData: {
      type: Array,
      default: () => [],
    },
    baseHeight: {
      type: Number,
      default: 1000,
    },
    localItemIndex: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    localItemIndex(newValue) {
      this.checkedIndex = newValue;
    },
  },
  created() {},
  methods: {
    qimoChatClick() {
      this.$trackEvent("马上学习", "点击", "马上学习")
      window.qimoChatClick();
    },
    itemClick(index, item) {
      this.$trackEvent(item.desc, "点击", item.desc)
      this.checkedIndex = index;
      let localHeight =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      this.localHeight = localHeight;
      let realIndex = index;
      if (index == 0) {
        realIndex = 0;
      } else {
        realIndex = index + 1;
      }
      let nextHeight =
        this.baseHeight +
        document.querySelector(".divOffsetParent").children[realIndex]
          .offsetTop;
      if(realIndex === this.flowData.length){
        nextHeight = nextHeight +125;
      }
      this.nextHeight = nextHeight;
      if (localHeight > nextHeight) {
        this.smoothUp();
      } else {
        this.smoothDown();
      }
    },
    smoothDown() {
      if (this.localHeight < this.nextHeight) {
        this.localHeight += this.speed;
        document.body.scrollTop = this.localHeight;
        document.documentElement.scrollTop = this.localHeight;
        setTimeout(this.smoothDown, 10);
      } else {
        document.body.scrollTop = this.nextHeight;
        document.documentElement.scrollTop = this.nextHeight;
      }
    },
    smoothUp() {
      if (this.localHeight - this.nextHeight > this.speed) {
        this.localHeight -= this.speed;
        document.body.scrollTop = this.localHeight;
        document.documentElement.scrollTop = this.localHeight;
        setTimeout(this.smoothUp, 0);
      } else {
        document.body.scrollTop = this.nextHeight;
        document.documentElement.scrollTop = this.nextHeight;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../scss/flowWidget.scss";
</style>
